module.exports = __webpack_public_path__ + "static/img/samajuri (36).90dca97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (36).jpg
// module id = HZb1
// module chunks = 0